import { allContentRoutes } from './views/all/all.router';
import All from './views/all/all.vue';
import ClassesView from './views/classes/classes.view.vue';

export const MY_CONTENT_ROUTES = {
  ALL: {
    NAME: 'private.myContent.all',
    PATH: 'all'
  },
  CLASSES: {
    NAME: 'private.myContent.classes',
    PATH: 'classes/:id'
  }
};

export const myContentRoutes = [
  { 
    name: MY_CONTENT_ROUTES.ALL.NAME,
    path: MY_CONTENT_ROUTES.ALL.PATH,
    component: All,
    children: allContentRoutes
  },
  { 
    name: MY_CONTENT_ROUTES.CLASSES.NAME,
    path: MY_CONTENT_ROUTES.CLASSES.PATH,
    component: ClassesView
  }
];